export const testAttributes = {
    MULTI_CHOICE_CTA_CONTAINER: 'multi-choice-cta-container',
}

export const wpQlmultictaClass = 'wp-block-cdm-customizations-qlmulticta';

export const tags = ['h3', 'a'];
